import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "reactstrap";
import { isBiro } from "../../utils/helper";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { templateDaftarAsetCsv, uploadPegawaiCsv } from "../../api";
import { Input, Button as ButtonS } from "semantic-ui-react";
import fileDownload from "js-file-download";

export const HeaderComp = () => {
  const [isDownload, setIsDownload] = useState(false);
  const [modal, setModal] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const downloadTemplate = async () => {
    setIsDownload(true);
    try {
      const res = await templateDaftarAsetCsv();
      fileDownload(res.data, "template.csv");
    } catch (err) { }
    setIsDownload(false);
  }

  const handleUpload = async () => {
    setLoading(true);
    try {
      await uploadPegawaiCsv(file);
      setFile(null);
      toggle();
    } catch (err) { }
    setLoading(false);
  }

  const toggle = () => setModal(!modal);

  return (
    <>
      <div className="card border-0 rounded-0">
        <div className="container py-4">
          <div className="row px-4">
            <div className="col-md-6 d-flex align-items-center mb-md-0 mb-3">
              <h3>Daftar Aset</h3>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              {(
                <>
                  {/* <NavLink onClick={downloadTemplate}>
                    <Button color="success" disabled={isDownload}>Download Template CSV</Button>
                  </NavLink>
                  <NavLink onClick={() => setModal(true)} >
                    <Button color="success">Import CSV</Button>
                  </NavLink> */}
                  <NavLink tag={Link} to="/daftar-aset/tambah">
                    <ButtonS color="blue">+ &nbsp; Tambah</ButtonS>
                  </NavLink>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Import CSV</ModalHeader>
        <ModalBody>
          <Input
            type="file"
            fluid
            onChange={(e) => setFile(e.target.files[0])}
          />
          <div className="my-2"></div>
          <ButtonS color="blue" fluid onClick={handleUpload} loading={loading}>Upload</ButtonS>
        </ModalBody>
      </Modal>
    </>
  );
};
